<template>
  <el-dialog v-loading="isLoading" :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh"
    :before-close="handleClose" @open="onDialogOpen">
    <template #title>
      <span class="el-dialog__title">观看视频</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <video :src="fileUrl" controls />
    </div>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";
import { getBlobFileUrlById } from "@/service/blobStorage.service";

export default {
  name: "videoViewer",
  mixins: [mixinDevice],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    fileId: {
      type: Number,
      default: null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      fileUrl: null,
    };
  },
  created() {
    this.reloadVisible();
  },
  mounted() {},
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
  },
  methods: {
    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible !== newValue) this.dialogVisible = newValue;
    },
    resetData() {},
    showDialog() {
      this.getFilePath();

      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.resetData();

      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {},
    handleClose(done) {
      this.closeDialog();
    },
    getFilePath(item) {
      if (!this.fileId) return;

      this.isLoading = true;
      getBlobFileUrlById(this.fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            this.fileUrl = Url;
            this.isLoading = false;
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
            this.fileUrl = null;
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;
  text-align: center;

  video {
    width: 480px;
    height: 270px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/videoViewer.vue